import { inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@modules/auth/services/auth.service';

export const rolesGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const snackBar = inject(MatSnackBar);

  const allowedRoles = route.data && route.data['roles'] ? route.data['roles'] as string[] : [];

  if (!authService.isAuthenticated()) {
    snackBar.open('Você precisa estar autenticado para acessar esta página.', 'Fechar', { duration: 2000 });
    router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    return false;
  }

  if (!allowedRoles || allowedRoles.length === 0) {
    snackBar.open('Acesso negado.', 'Fechar', { duration: 2000 });
    router.navigate(['/']);
    return false;
  }

  const hasAny = allowedRoles.some(r => authService.hasRole(r));
  if (hasAny) return true;

  snackBar.open('Acesso negado.', 'Fechar', { duration: 2000 });
  router.navigate(['/']);
  return false;
};
